import { Injectable } from '@angular/core';
import { UserSession } from './user-session';

@Injectable()
export class HolisticMemberProfileService {
  constructor(private userSession: UserSession) {}

  setClientFlags() {

    const memberProfile = this.userSession.getMemberProfile();
    if (memberProfile) {
      memberProfile.memberFeatureFlags = {
        ...memberProfile.memberFeatureFlags,
        ...this.getBlueRewardsFeatureFlags(),
        ...this.getHealthAssessmentOnlineCoachingClientFlags()
      };
    }
  }

  isGroup(): boolean {
    return this.userSession.getMemberAttributes().asuIndicator !== 'IMD';
  }

  isMedicalCovered(): boolean {
    const {
      medicalCoverageActive,
      medicalCoveragePreactive
    } = this.userSession.getMemberCoverageFlags();
    return medicalCoverageActive || medicalCoveragePreactive;
  }

  isDentalCovered(): boolean {
    const {
      dentalCoverageActive,
      dentalCoveragePreactive,
      pediatricDentalCoverageActive,
      pediatricDentalCoveragePreactive
    } = this.userSession.getMemberCoverageFlags();
    return (
      dentalCoverageActive ||
      dentalCoveragePreactive ||
      pediatricDentalCoverageActive ||
      pediatricDentalCoveragePreactive
    );
  }

  isDrugCovered(): boolean {
    const { drugCoverageActive, drugCoveragePreactive } = this.userSession.getMemberCoverageFlags();
    return drugCoverageActive || drugCoveragePreactive;
  }

  isVisionCovered(): boolean {
    const {
      visionCoverageActive,
      visionCoveragePreactive,
      pediatricVisionCoverageActive,
      pediatricVisionCoveragePreactive,
      adultEmbeddedVisionCoverageActive,
      adultEmbeddedVisionCoveragePreactive
    } = this.userSession.getMemberCoverageFlags();
    return (
      visionCoverageActive ||
      visionCoveragePreactive ||
      pediatricVisionCoverageActive ||
      pediatricVisionCoveragePreactive ||
      adultEmbeddedVisionCoverageActive ||
      adultEmbeddedVisionCoveragePreactive
    );
  }

  isDentalActiveCovered(): boolean {
    const {
      dentalCoverageActive,
      pediatricDentalCoverageActive
    } = this.userSession.getMemberCoverageFlags();
    return dentalCoverageActive || pediatricDentalCoverageActive;
  }

  isVisionActiveCovered(): boolean {
    const {
      visionCoverageActive,
      pediatricVisionCoverageActive,
      adultEmbeddedVisionCoverageActive
    } = this.userSession.getMemberCoverageFlags();
    return (
      visionCoverageActive || pediatricVisionCoverageActive || adultEmbeddedVisionCoverageActive
    );
  }

  isBlueRewardMember(): boolean {
    if (this.userSession.getMemberAttributes().incnProgName === 'Blue Rewards') {
      return true;
    } else {
      return false;
    }
  }

  isWellnessMember(): boolean {
    if (this.userSession.getMemberAttributes().incnProgName === 'Wellness') {
      return true;
    } else {
      return false;
    }
  }

  isWellnessSOMMember(): boolean {
    if (this.userSession.getMemberAttributes().incnProgName === 'Wellness Tracker') {
      return true;
    } else {
      return false;
    }
  }

  isWellnessAuthPending(): boolean {
    return (this.userSession.getMemberFeatureFlags().showGINAAuth && !this.userSession.getMemberAttributes().ginaAuthOptionalInd && !this.userSession.getMemberAttributes().ginaAuthStatusInd) ||
      (this.userSession.getMemberFeatureFlags().showHIPAAAuth && !this.userSession.getMemberAttributes().hipaaAuthOptionalInd && !this.userSession.getMemberAttributes().hipaaAuthStatusInd) ||
      (this.userSession.getMemberFeatureFlags().showBRAuth && !this.userSession.getMemberAttributes().brTermsAuthOptionalInd && !this.userSession.getMemberAttributes().brTermsAuthStatusInd);
  }

  isWellnessAuthApplicable(): boolean {
    return this.userSession.getMemberFeatureFlags().showGINAAuth || this.userSession.getMemberFeatureFlags().showHIPAAAuth || this.userSession.getMemberFeatureFlags().showBRAuth;
  }

  showHAOnlineCoachingHW(): boolean {
    if (this.userSession.getMemberFeatureFlags().showBlueRewards && !this.isWellnessSOMMember()) {
      if (this.userSession.getMemberAttributes().brEEOCApplicableInd && this.isWellnessAuthApplicable() && (this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW) === true) {
        return true;
      }
      else ((this.userSession.getMemberAttributes().brEEOCApplicableInd && this.isWellnessAuthApplicable() && (this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW) === false))
      {
        return false;
      }

    } else if (this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW) {
      return true;
    }
    else ((this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW) === false)
    return false;
  }

  showHAOnlineCoachingHIFT(): boolean {
    if (this.userSession.getMemberFeatureFlags().showBlueRewards && !this.isWellnessSOMMember()) {
      if (this.userSession.getMemberAttributes().brEEOCApplicableInd && this.isWellnessAuthApplicable() && (this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT) === true) {
        return true;
      }
      else ((this.userSession.getMemberAttributes().brEEOCApplicableInd && this.isWellnessAuthApplicable() && (this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT) === false))
      {
        return false;
      }

    } else if (this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT) {
      return true;
    }
    else ((this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT) === false)
    return false;
  }




  showHAOnlineCoachingBR(): boolean {
    if (this.userSession.getMemberFeatureFlags().showBlueRewards && !this.isWellnessSOMMember()) {
      if (!(this.userSession.getMemberAttributes().brEEOCApplicableInd && this.isWellnessAuthApplicable()) && (this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT || this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW) === true) {
        return true;
      }
      else if (!(this.userSession.getMemberAttributes().brEEOCApplicableInd && this.isWellnessAuthApplicable()) && (this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT || this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW) === false) {
        return false;
      } else
        return;
    }
  }


  isMemberRenewed(): boolean {
    const isMemberRenew = false;
    let planStartDate;
    const cutoffDate = new Date('01/01/2018'); // needs to change to 01/01/2018 // 11/01/2017 (SIT)

    if (this.userSession.getMemberAttributes().planStartDate !== null && this.userSession.getMemberAttributes().planStartDate !== '') {
      planStartDate = new Date(this.userSession.getMemberAttributes().planStartDate);
      if (planStartDate >= cutoffDate) {
        return true;
      }
    }
    return false;
  }

  /**
   * check Enrollment flag
   */
  get isEnrollment() : boolean {
    return (this.userSession.getMemberAttributes().studentHealthPlan || this.userSession.getMemberFeatureFlags().showEnrollmentMaintenance || this.userSession.getMemberFeatureFlags().showEnrollmentMaintenance || this.userSession.getMemberFeatureFlags().showLifeEventChanges);
     
  }

  isHouseAccount():boolean{
    let houseAccountModel= this.userSession.getMemberAttributes().incnModelLogicalName;
    let regExp = /^2017_/g;
    let houseAccountModelStart;
    if(houseAccountModel){
     houseAccountModelStart = houseAccountModel.match(regExp);
    }
    if(houseAccountModelStart!==undefined && houseAccountModelStart !==null && houseAccountModelStart.toString() === '2017_' && this.userSession.getMemberAttributes().houseAccount === true){
        return true;
      }else{
        return false;
    }
  }

   //House account Wellness SVET changes start
   isHouseAccountModelCheck():boolean {
    return this.userSession.getMemberAttributes().incnModelLogicalName === "2017_House_Account_Wellness_Only";
  }

  //House Account Wellness SVET changes start
  isChild():boolean {
    if (this.userSession && this.userSession.getMemberProfile().memberKey) {
        return this.userSession.getMemberProfile().memberKey.relationship === '19';
    }
    return null;
}

isHealthyBlueMember():boolean{
  if(this.userSession.getMemberAttributes().incnProgName ==='Healthy Blue'){
    return true;
  }else{
    return false;
  }
}

showBlueRewardsClientFlag():boolean{
 if(this.userSession.getMemberFeatureFlags().showBlueRewards){
   if(this.isBlueRewardMember()){
     if(!this.isHouseAccount()){
          return true;
     }
   }
 }
 if(!this.isHouseAccount() && this.userSession.getMemberFeatureFlags().showBlueRewards){
    return true;
 }  
 return false;
}

showWellnessOnlyMemberClientFlag():boolean{
  if(this.isWellnessMember()){
    if(this.isHouseAccount() && this.isChild() && this.isHouseAccountModelCheck()){
      return false;
    }else{
      return true;
    }
  }
  if(!this.isHouseAccount() && this.userSession.getMemberFeatureFlags().showBlueRewards){
    return false;
  } 
  return false;
}

showSOMWellnessMemberClientFlag():boolean{
  if(this.isWellnessSOMMember()){
    return true;
  }
  if(!this.isHouseAccount() && this.userSession.getMemberFeatureFlags().showBlueRewards){
    return false;
  }
  return false;
}

showHealthyBlueClientFlag():boolean{
  if(this.isHealthyBlueMember()){
    return true;
  }
  return false;
}

isBrEConsentApplicable():boolean{
  if(this.userSession.getMemberAttributes().brEConsentApplicable ===true){
    return true;
  }else{
    return false;
  }

}

//Welness Auth changes
getSecUserAuth(key){
  var secureUserKey = 'is'+key.replace(/_+/g, '')+'Authenticated';
  return this[secureUserKey];
}

//Welness Auth changes
setSecUserAuth(key,value){
  //console.log("at setSecUserAuth method " +  key + " " + value);
  var secureUserKey = 'is'+key.replace(/_+/g, '')+'Authenticated';
  this[secureUserKey] = value;
}

isAccountTermed() {
  return (!this.userSession.getMemberAttributes().active && !this.userSession.getMemberAttributes().preactive);
}

isSubscriber() {
  return this.userSession.getMemberProfile().memberKey.relationship === '18';
}

private getBlueRewardsFeatureFlags() {
  const blueRewardsFlags = {
    // Healthy Blue
    showHealthyBlueClientFlag: false,
     // BR && not house account
    showBlueRewardsClientFlag: false,
    // FORMS Flags
    showHealthyBlueFormClientFlag: false,
    showBlueRewardsFormClientFlag: false,
    // Wellness Member (should be hidden for children)
    showWellnessOnlyMemberClientFlag: false,
    // Wellness SOM (State of Maryland)
    showSOMWellnessMemberClientFlag: false,
    // BR && house account (should be hidden for children)
    showBlueRewardsHouseAccountClientFlag: false,

    showBWTermedClientFlag: false
  };

  if (this.userSession.isDataLoaded) {
    blueRewardsFlags.showHealthyBlueClientFlag = false;
    blueRewardsFlags.showBlueRewardsClientFlag = false;

    blueRewardsFlags.showHealthyBlueFormClientFlag = false;
    blueRewardsFlags.showBlueRewardsFormClientFlag = false;

    blueRewardsFlags.showWellnessOnlyMemberClientFlag = false;
    blueRewardsFlags.showSOMWellnessMemberClientFlag = false;
    blueRewardsFlags.showBlueRewardsHouseAccountClientFlag = false;

    const cvsMinuteClinicApplicable = this.userSession.getMemberAttributes().brCVSMinuteClinicApplicable;
    const onsiteScreeningApplicable = this.userSession.getMemberAttributes().brOnsiteScreeningApplicable;
    const showHealthScreeingOptions = (cvsMinuteClinicApplicable || onsiteScreeningApplicable) ? true : false;

    if (this.userSession.getMemberFeatureFlags().showBlueRewards) {
      if (this.isBlueRewardMember()) {
        if (this.isHouseAccount()) {
          if (this.isChild() && this.isHouseAccountModelCheck()) {
            blueRewardsFlags.showBlueRewardsHouseAccountClientFlag = false;
          } else {
            blueRewardsFlags.showBlueRewardsHouseAccountClientFlag = true;
          }
        } else {
          blueRewardsFlags.showBlueRewardsClientFlag = true;
          if (!showHealthScreeingOptions) {
            blueRewardsFlags.showBlueRewardsFormClientFlag = true;
          }
        }
      } else if (this.isHealthyBlueMember()) {
        blueRewardsFlags.showHealthyBlueClientFlag = true;
        if (!showHealthScreeingOptions) {
          blueRewardsFlags.showHealthyBlueFormClientFlag = true;
        }
      } else if (this.isWellnessMember()) {
        if (this.isHouseAccount() && this.isChild() && this.isHouseAccountModelCheck()) {
          blueRewardsFlags.showWellnessOnlyMemberClientFlag = false;
        } else {
          blueRewardsFlags.showWellnessOnlyMemberClientFlag = true;
        }
      } else if (this.isWellnessSOMMember()) {
        blueRewardsFlags.showSOMWellnessMemberClientFlag = true;
      }
    }
    if (!this.isHouseAccount() && this.userSession.getMemberFeatureFlags().showBlueRewards && !this.isWellnessSOMMember()) {
      blueRewardsFlags.showBlueRewardsClientFlag = true;
      blueRewardsFlags.showSOMWellnessMemberClientFlag = false;
      blueRewardsFlags.showWellnessOnlyMemberClientFlag = false;
      blueRewardsFlags.showBlueRewardsHouseAccountClientFlag = false;
    }
  }

  blueRewardsFlags.showBWTermedClientFlag =  
    this.isSubscriber() && 
    ( this.isAccountTermed() && 
    ((this.userSession.getMemberFeatureFlags().allowBlueRewardsIncentiveBalancesTransactionsBW) || 
    this.userSession.getMemberFeatureFlags().allowBlueRewardsIncentiveBalancesTrnstnsTermedBW) || 
    ((this.userSession.getMemberFeatureFlags().allowBlueRewardsIncentiveBalancesTransactions) || 
    this.userSession.getMemberFeatureFlags().allowBlueRewardsIncentiveBalancesTrnstnsTermed));

  return blueRewardsFlags;
}

  private getHealthAssessmentOnlineCoachingClientFlags() {
    const healthAssessmentOnlineCoachingClientFlags = {
      memberRenewedClientFlag: false,
      memberNotRenewedClientFlag: false,
      showHAOnlineCoachingHWClientFlag: false,
      showHAOnlineCoachingHIFTClientFlag: false,
      showHAOnlineCoachingBRClientFlag: false
    };

    if (this.isMemberRenewed()) {
      healthAssessmentOnlineCoachingClientFlags.memberRenewedClientFlag = true;
    } else {
      healthAssessmentOnlineCoachingClientFlags.memberNotRenewedClientFlag = true;
    }

    const isWellnessAuthApplicable = this.userSession.getMemberFeatureFlags().showGINAAuth || this.userSession.getMemberFeatureFlags().showHIPAAAuth || this.userSession.getMemberFeatureFlags().showBRAuth;

    if (this.userSession.getMemberFeatureFlags().showBlueRewards && !this.isWellnessSOMMember()) {
      if (this.userSession.getMemberAttributes().brEEOCApplicableInd && isWellnessAuthApplicable) {
        healthAssessmentOnlineCoachingClientFlags.showHAOnlineCoachingHWClientFlag = this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW;
        healthAssessmentOnlineCoachingClientFlags.showHAOnlineCoachingHIFTClientFlag = this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT;
      }else {
        healthAssessmentOnlineCoachingClientFlags.showHAOnlineCoachingBRClientFlag = this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT || this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW;
      }
    }else{
      healthAssessmentOnlineCoachingClientFlags.showHAOnlineCoachingHWClientFlag = this.userSession.getMemberFeatureFlags().showBlueRewardsHW || this.userSession.getMemberFeatureFlags().showWellnessHW;
      healthAssessmentOnlineCoachingClientFlags.showHAOnlineCoachingHIFTClientFlag = this.userSession.getMemberFeatureFlags().showBlueRewardsHFIT || this.userSession.getMemberFeatureFlags().showWellnessHFIT;
    }
    // console.log(healthAssessmentOnlineCoachingClientFlags);
    return healthAssessmentOnlineCoachingClientFlags;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/holistic-member-profile.service.ts